import _Object$keys from 'babel-runtime/core-js/object/keys';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';

import _get from 'lodash/get';
import _set from 'lodash/set';
import gameIframe from '@ps/bridge/iframe/iframe';

export default {
  components: {
    // SceneTextureDialog,
  },
  data: function data() {
    return {
      currentEdit: { key: null, value: null },
      countCache: '0',
      tableData: []
    };
  },

  props: {
    config: {
      type: Object,
      required: true
    },
    model: {
      type: Object,
      required: true
    }
  },
  watch: {
    countOriginal: function countOriginal(newVal) {
      this.countCache = newVal;
    }
  },
  computed: {
    countOriginal: {
      get: function get() {
        return this.tableData.length.toString();
      },
      set: function set(newVal) {
        newVal = Math.floor(newVal);
        newVal = !isNaN(newVal) && newVal >= 0 ? newVal : 0; // 检查输入是否合法
        var diff = newVal - this.countOriginal;
        var cloneData = JSON.parse(_JSON$stringify(this.originData));
        if (diff > 0) {
          // 增
          while (diff) {
            var uuid = gameIframe.qcGame.math.uuid();
            cloneData[uuid] = '';
            diff -= 1;
          }
        } else if (diff < 0) {
          // 删
          while (diff) {
            var temp = this.tableData[this.tableData.length + diff];
            delete cloneData[temp.key];
            diff += 1;
          }
        }
        this.originData = cloneData;
        this.refreshTable();
      }
    },
    originData: {
      get: function get() {
        return _get(this.model, this.config.prop) || {};
      },
      set: function set(newV) {
        var prop = this.realProp();
        _set(this.model.script, prop, newV);
        _set(this.model, this.config.prop, newV);
      }
    }
    // tableData() {
    //   const data = []
    //   Object.keys(JSON.parse(JSON.stringify(this.originData))).forEach(
    //     (key) => {
    //       data.push({ key, value: this.originData[key] })
    //     },
    //   )
    //   return data
    // },
  },
  methods: {
    realProp: function realProp() {
      var index = this.config.prop.lastIndexOf('.');
      if (index === -1) {
        return this.config.prop;
      }
      return this.config.prop.slice(0, index);
    },
    countBlur: function countBlur() {
      this.countOriginal = this.countCache;
    },
    focusInput: function focusInput(row) {
      this.currentEdit.key = row.key;
      this.currentEdit.value = row.value;
    },
    alterData: function alterData(row, column) {
      var cloneData = JSON.parse(_JSON$stringify(this.originData));
      cloneData[row.key] = row.value;
      if (this.currentEdit.key !== row.key) {
        // 改了键
        delete cloneData[this.currentEdit.key];
      }
      this.originData = cloneData;
    },
    refreshTable: function refreshTable() {
      var _this = this;

      this.tableData = [];
      _Object$keys(JSON.parse(_JSON$stringify(this.originData))).forEach(function (key) {
        _this.tableData.push({ key: key, value: _this.originData[key] });
      }); // tableData初始化
    }
  },
  beforeMount: function beforeMount() {
    this.countCache = this.tableData.length.toString();
    this.refreshTable();
  }
};